export const ASSISTANT_BREAKPOINT_PX = 1024;

export type AssistantDisplayMode = 'rail' | 'overlay' | 'fab';

export function isAssistantDesktopViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(`(min-width: ${ASSISTANT_BREAKPOINT_PX}px)`).matches;
}

export interface AssistantDisplayModeInput {
  isDesktop: boolean;
  railOpen?: boolean;
  isOpen?: boolean;
}

/**
 * Resolves how the global voice assistant should present at the current viewport.
 * - Desktop + railOpen → fixed right rail
 * - Desktop + !railOpen → FAB trigger only
 * - Mobile/tablet + isOpen → full-screen overlay
 * - Mobile/tablet + !isOpen → FAB trigger only
 */
export function getAssistantDisplayMode({
  isDesktop,
  railOpen = true,
  isOpen = false,
}: AssistantDisplayModeInput): AssistantDisplayMode {
  if (!isDesktop) {
    return isOpen ? 'overlay' : 'fab';
  }

  return railOpen ? 'rail' : 'fab';
}

export function subscribeAssistantViewport(onChange: (isDesktop: boolean) => void): () => void {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const mediaQuery = window.matchMedia(`(min-width: ${ASSISTANT_BREAKPOINT_PX}px)`);
  const handler = () => onChange(mediaQuery.matches);

  mediaQuery.addEventListener('change', handler);
  return () => mediaQuery.removeEventListener('change', handler);
}
